<div>
    <h4 class="modal-content__heading" name="numpadHeader">{{numpadTitle}}</h4>
</div>
<div class="modal-body pt-0">
    <pos-numpad numpadId="{{numpadId}}" [value]="value" [options]="numpadOption"
        [onCancel]="onCancel" [onSubmit]="onSubmit">
    </pos-numpad>
</div>
